<div class="autocomplete">
  <ng-autocomplete
    [data]="accounts"
    [searchKeyword]="'id'"
    placeholder="Search for account id"
    (selected)="selectEvent($event)"
    [itemTemplate]="itemTemplate"
    [notFoundTemplate]="notFoundTemplate"
    [formControl]="accountDomainControl"
  >
  </ng-autocomplete>
  <ng-template #itemTemplate let-item>
    <a [innerHTML]="item.id"></a>
  </ng-template>

  <ng-template #notFoundTemplate let-notFound>
    <div [innerHTML]="notFound"></div>
  </ng-template>
</div>
<div class="name-control">
  <input
    class="name"
    [ngClass]="{ hasError: !accountDomainNameControl.valid }"
    type="text"
    placeholder="Domain name"
    [formControl]="accountDomainNameControl"
  />
  <div class="name--hasError" *ngIf="!accountDomainNameControl.valid">
    Domain should not contain spaces
  </div>
</div>
